import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router'
import './index.css'
import { sendCustomRequest } from '../../restClient'
import Layout from '../../layout'
import Success from './success'
import Error from './error'
import loader from './images/loader.svg'

const CouponForm = ({ match = {} }) => {
    const { params: { locale = 'en', hash = null } = {} } = match
    const [loading, setLoading] = useState(true)
    const [content, setContent] = useState({})

    if (!hash) {
        setContent({
            type: 'error',
            name: 'error'
        })
    }

    useEffect(() => {
        if (hash) {
            setLoading(true)
            sendCustomRequest(`coupon/activation/${hash}`, {
                method: 'POST',
                headers: new Headers({'x-adviqo-app-language': locale}),
            })
              .then(() => setContent({type: 'success'}))
              .catch((error) => setContent({
                  type: 'error',
                  message: error.body && error.body.localizedMessage
              }))
              .then(() => setLoading(false))
        }
    }, [hash])

    const Content = ({ content }) => {
        const { type = '', message } = content

        switch (type) {
            case 'error':
                return (<Error message={message} />)
            case 'success':
                return (<Success locale={locale}/>)
            default:
                return null
        }
    }

    if (loading) {
        return (
            <Layout showHeader={false}>
                <div className="layout-loading-box">
                    <img src={loader} className="layout-loading" alt="Loading" />
                </div>
            </Layout>
        )
    }

    return (
        <Layout showHeader={false} className='coupon-activation-container'>
            <div className="subscribe-template">
                <Content content={content}/>
            </div>
        </Layout>
    )
}

export default withRouter(CouponForm)



// WEBPACK FOOTER //
// ./src/components/coupon/index.js